import SiafLiteApiRepository from "../../external/siafLiteApi";

class ColaboradorSevicoService {
  constructor() {
    this.urlBase = "/integracao/colaboradores";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }
}

export default ColaboradorSevicoService;
